import { useState } from "react";
import dayjs from "dayjs";
import { ChevronUp } from "lucide-react";

import { TableRow } from "@/components/common/table/table";
import { Ellipse } from "@/components/common/svgs";
import { LoadboardDate, LoadboardTableCell, TableWidths, LoadboardTime, LoadboardToggleRow } from "@/components/dataPages/loadboard";
import { CurrencyText, LocationText, TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import * as React from "react";
import { getLoadId } from "@/utils/load";

export const LoadboardTableRow = ({ load, index }) => {
    const [isOpen, setIsOpen] = useState(false);
    const idToShow = load.externalLoadId || getLoadId(load.uniqueId);
    const timestamp = load.updatedAt || load.createdAt;
    const diffSeconds = timestamp ? dayjs().diff(dayjs(timestamp), "seconds") : -1;
    const diffMinutes = timestamp ? dayjs().diff(dayjs(timestamp), "minutes") : -1;
    const diffHours = timestamp ? dayjs().diff(dayjs(timestamp), "hours") : -1;
    const diffDays = timestamp ? dayjs().diff(dayjs(timestamp), "days") : -1;

    const ageWhen =
        diffSeconds === -1
            ? "-"
            : diffMinutes === 0
              ? `${diffSeconds} sec`
              : diffMinutes < 60
                ? `${diffMinutes} min`
                : diffHours < 24
                  ? `${diffHours} hr`
                  : `${diffDays} day${diffDays > 1 ? "s" : ""}`;

    return (
        <>
            <TableRow
                className={cn("hover:bg-cm-p-surface-hover bg-cm-p-surface overflow-hidden border-t-[1px] border-cm-p-outline border-b-0", {
                    "border-0": !index,
                    "opacity-40": load.isUnavailable,
                })}
            >
                <LoadboardTableCell className={`${TableWidths[0]} leading-[22px]`} innerClassName="pt-[14px] px-[5px] flex justify-end">
                    <Ellipse isAvailable={load.allowedActions?.length && !load.isUnavailable} />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[1]} text-cm-p-text-secondary`}>{ageWhen}</LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[2]}`}>{idToShow}</LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[3]}`}>
                    <LocationText city={load.itineraryStops[0]?.stopCity} state={load.itineraryStops[0]?.stopState} />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[4]}`}>
                    <LocationText
                        city={load.itineraryStops[load.itineraryStops.length - 1]?.stopCity}
                        state={load.itineraryStops[load.itineraryStops.length - 1]?.stopState}
                    />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[5]}`} innerClassName="flex flex-col">
                    <>
                        <LoadboardDate date={load.pickupDate} />
                        <LoadboardTime stop={load.itineraryStops[0]} />
                    </>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[6]}`} innerClassName="flex flex-col">
                    <>
                        <LoadboardDate date={load.deliveryDate} />
                        <LoadboardTime stop={load.itineraryStops[load.itineraryStops.length - 1]} />
                    </>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[7]}`} innerClassName="flex flex-col">
                    <div>{load.loadDistance ? `${Math.round(load.loadDistance)} mi` : "-"}</div>
                    {load.itineraryStops.length > 2 ? (
                        <div className="text-cm-p-text-secondary text-xs/[19px]">
                            {load.itineraryStops.length - 2}{" "}
                            <TranslatedText>{load.itineraryStops.length > 3 ? "stops" : "stop"}</TranslatedText>
                        </div>
                    ) : null}
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[8]}`}>
                    {load.brokerInfo?.name ? `${load.brokerInfo.name}` : "-"}
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[9]}`}>
                    <div className="flex items-center">
                        <div className="w-[52px] text-right mr-4">
                            {load.offerRate ? <CurrencyText className="font-semibold text-sm/[19px]" num={load.offerRate} round /> : "-"}
                        </div>
                        <div className="bg-cm-p-outline h-3 w-[1px]" />
                        <div className="w-[52px] ml-1 text-right">
                            {load.rpm ? <CurrencyText className="text-sm/[19px] font-normal" num={load.rpm} /> : "-"}
                        </div>
                    </div>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[10]}`} innerClassName="p-2 justify-end">
                    <button onClick={() => setIsOpen(!isOpen)} className="w-12 h-12 inline-flex justify-center items-center">
                        <ChevronUp
                            className={cn("w-6 transition-transform", {
                                "rotate-180": !isOpen,
                            })}
                        />
                    </button>
                </LoadboardTableCell>
            </TableRow>
            <LoadboardToggleRow load={load} isOpen={isOpen} />
        </>
    );
};
